import { TranslateService } from '@ngx-translate/core';
import { Notification, NotificationData } from './notification.model';

export class PaymentNotification extends Notification {
  constructor(
    data: NotificationData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
    if (this.payment) {
      this.description = this.translateService.instant(
        this.payment.paid ? 'payment_settled_description' : 'payment_outstanding_description',
        {
          amount: this.payment.paymentAmount,
          doctor: this.payment.treatingDoctor,
        },
      );
      this.actionName = this.payment.paid ? this.translateService.instant('view') : this.translateService.instant('pay_now');
      this.actionRequired = !this.payment.paid;
    }
  }
}
